const Input = ({ id, label, value, onChange,name, readOnly = false, style = {}, type = "text" , hasError = false }) => (
  <div className="form-floating mb-2">
    <input
      type={type}
      className={`form-control p-0 px-2 ${readOnly ? "custom-readonly" : ""} ${hasError ? "errorborder" : ""}`}
      style={{ fontSize: "0.8rem", ...style }}
      id={id}
      name={name}
      placeholder={label} 
      value={value}
      onChange={onChange}
      disabled={readOnly}

    />
    <label htmlFor={id} className={`${!readOnly ? 'customBGwhiteBG' : "customBG"}`} style={{ fontSize: "0.8rem", color: "#212529a6",padding:'0.5rem 0.75rem' }}>
      {label}
    </label>
  </div>
);

export default Input;


